import { HttpClient , HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from '../../environments/environment';
// import { SocialAuthService } from "@abacritt/angularx-social-login";
// import { FacebookLoginProvider } from '@abacritt/angularx-social-login';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private auth = new BehaviorSubject(false);
  private user = new BehaviorSubject(<any>null);
  private selectLocation = new BehaviorSubject(<any>null);
  private sasToken = new BehaviorSubject('');
  public dataSource = new BehaviorSubject<boolean>(false);
  currentSasToken = this.sasToken.asObservable();

  // constructor(private http: HttpClient, private authService: SocialAuthService) { }
  constructor(private http: HttpClient) { }

  // output to Auth Guard and Other Component
  getAuth(): Observable<boolean> {
    return this.auth.asObservable();
  }

  getUser(): Observable<any> {
    return this.user.asObservable();
  }

  // getLocation(): Observable<any> {
  //   return this.selectLocation.asObservable();
  // }

  // updateLocation(selectLocation:any){
  //   this.selectLocation.next(selectLocation);
  // }

  // If login is true
  updateUserAuth(authState: boolean, user: any) {
    this.auth.next(authState);
    this.user.next(user);
  }

  logout() {
    const url = `${environment.apiUrl}user/logout`;
    return this.http.post(url, {});
  }

  registerNewUser(registerData: any) {
    const url = `${environment.apiUrl}user/register/verify`;
    return this.http.post(url, registerData.data);
  }

  registerSendOtp(registerData: any) {
    const url = `${environment.apiUrl}user/register/send`;
    return this.http.post(url, registerData.data);
  }

  sendOtp(otpData: any) {
    const url = `${environment.apiUrl}user/login/otp/send`;
    return this.http.post(url, otpData.data);
  }

  loginByEmail(loginData: any) {
    const url = `${environment.apiUrl}user/email-login`;
    return this.http.post(url, loginData.data);
  }

  verifyOtp(otpData: any) {
    const url = `${environment.apiUrl}user/login/otp/verify`;
    return this.http.post(url, otpData.data);
  }

  sendEnquiry(enquiryData: any) {
    const url = `${environment.apiUrl}common/send-enquiry`;
    return this.http.post(url, enquiryData.data);
  }

  sendFeedback(feedbackData: any) {
    const url = `${environment.apiUrl}common/feedback/add`;
    return this.http.post(url, feedbackData);
  }

  socialLogin(loginData: any) {
    const url = `${environment.apiUrl}user/social-login`;
    return this.http.post(url, loginData.data);
  }

  // signInWithFB(): void {
  //   this.authService.signIn(FacebookLoginProvider.PROVIDER_ID)
  // }

  // signOutSocial(): void {
  //   this.authService.signOut();
  // }

  forgotSendOtp(otpData: any) {
    const url = `${environment.apiUrl}user/forget/otp/send`;
    return this.http.post(url, otpData.data);
  }

  verifyForgotOtp(otpData: any) {
    const url = `${environment.apiUrl}user/forget/otp/verify`;
    return this.http.post(url, otpData.data);
  }

  submitForgotPassword(otpData: any) {
    const url = `${environment.apiUrl}user/forget/password`;
    return this.http.post(url, otpData.data);
  }

  getEncryptedData(beforeEncryptData: any) {
    return beforeEncryptData;
  }

  getDecryptData(afterEncryptData: any) {
    if (typeof afterEncryptData !== 'string') {
    return afterEncryptData;
  }

  try {
    return JSON.parse(afterEncryptData);
  } catch {
    return afterEncryptData;
  }
  }

  changeSastoken(token: string) {
    this.sasToken.next(token);
  }

  getSasToken(blobUrl: string) {
    const url = `${environment.apiUrl}common/upload/blob/sas-token?url=${encodeURIComponent(blobUrl)}`;
    return this.http.get(url);
  }

  getCityList(page: number, contentPerPage: number, searchKey: string) {
    const url = `${environment.apiUrl}admin/city/list?page=${page}&contentPerPage=${contentPerPage}&searchKey=${searchKey}`;
    return this.http.get(url);
  }
  getMileStone() {
    const url = `${environment.apiUrl}user/property/milestones`;
    return this.http.get(url);
  }

   alertRibbon() {
    const url = `${environment.apiUrl}user/property/alerts`;
    return this.http.get(url);
  }
  getTopTenProjects() {
    const url = `${environment.apiUrl}user/property/top-projects-list`;
    return this.http.get(url);
  }

}
